const SHIPPING_PROGRESS_SPEED = 350;

function animationDuration(track, fromProgress, toProgress) {
  const distance = Math.abs(track.clientWidth * (toProgress - fromProgress) / 100);
  return distance / SHIPPING_PROGRESS_SPEED * 1000;
}

function transitionHeadline(headline, text, reducedMotion) {
  if (!headline || !text || headline.textContent.trim() === text.trim()) return;

  if (reducedMotion) {
    headline.textContent = text;
    return;
  }

  headline.classList.add('simedge-free-shipping__headline--leaving');
  window.setTimeout(() => {
    headline.textContent = text;
    headline.classList.remove('simedge-free-shipping__headline--leaving');
    headline.classList.add('simedge-free-shipping__headline--entering');
    headline.getBoundingClientRect();
    window.requestAnimationFrame(() => {
      headline.classList.remove('simedge-free-shipping__headline--entering');
    });
  }, 320);
}

async function refreshProductShippingMeter(meter) {
  const sectionId = meter.dataset.sectionId;
  const track = meter.querySelector('.simedge-free-shipping__track');
  const confirmed = meter.querySelector('.simedge-free-shipping__confirmed');
  if (!sectionId || !track || !confirmed) return;

  const currentProgress = track.clientWidth
    ? confirmed.getBoundingClientRect().width / track.clientWidth * 100
    : Number(meter.dataset.confirmedProgress || 0);

  const url = new URL(window.location.href);
  url.searchParams.set('section_id', sectionId);
  url.searchParams.set('_simedge_shipping', Date.now().toString());

  try {
    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) return;

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const freshMeter = documentFragment.querySelector('[data-simedge-free-shipping][data-context="product"]');
    if (!freshMeter || !meter.isConnected) return;

    meter.replaceWith(freshMeter);

    const freshTrack = freshMeter.querySelector('.simedge-free-shipping__track');
    const freshConfirmed = freshMeter.querySelector('.simedge-free-shipping__confirmed');
    const freshPreview = freshMeter.querySelector('.simedge-free-shipping__preview');
    if (!freshTrack || !freshConfirmed) return;

    const targetProgress = Number(freshMeter.dataset.confirmedProgress || 0);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = animationDuration(freshTrack, currentProgress, targetProgress);

    freshConfirmed.style.width = `${currentProgress}%`;
    freshConfirmed.style.transition = 'none';
    if (freshPreview) freshPreview.style.opacity = '0';

    freshConfirmed.getBoundingClientRect();
    window.requestAnimationFrame(() => {
      freshConfirmed.style.transition = reducedMotion ? 'none' : `width ${duration}ms linear`;
      freshConfirmed.style.width = `${targetProgress}%`;

      window.setTimeout(() => {
        if (freshPreview) freshPreview.style.opacity = '';
      }, reducedMotion ? 0 : duration);
    });
  } catch (error) {
    // Behåll den befintliga mätaren om nätverket tillfälligt misslyckas.
  }
}

function refreshProductShippingMeters() {
  document.querySelectorAll('[data-simedge-free-shipping][data-context="product"]').forEach((meter) => {
    refreshProductShippingMeter(meter);
  });
}

function confirmProductShippingPreview(event) {
  const source = event?.detail?.data?.source || event?.detail?.data?.sourceId || event?.detail?.sourceId || '';
  const isSuccessfulProductAdd =
    (source === 'product-form-component' || source === 'product-addons') &&
    event?.detail?.data?.didError !== true;

  if (event?.detail?.data?.didError === true) return;
  if (!isSuccessfulProductAdd) {
    refreshProductShippingMeters();
    return;
  }

  document.querySelectorAll('[data-simedge-free-shipping][data-context="product"]').forEach((meter) => {
    if (meter.dataset.confirmed === 'true') return;

    const track = meter.querySelector('.simedge-free-shipping__track');
    const confirmed = meter.querySelector('.simedge-free-shipping__confirmed');
    const preview = meter.querySelector('.simedge-free-shipping__preview');
    if (!track || !confirmed || !preview) return;

    const confirmedProgress = Number(meter.dataset.confirmedProgress || 0);
    const projectedProgress = Number(meter.dataset.projectedProgress || confirmedProgress);
    const duration = animationDuration(track, confirmedProgress, projectedProgress);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    meter.dataset.confirmed = 'true';
    confirmed.style.transition = reducedMotion ? 'none' : `width ${duration}ms linear`;
    confirmed.style.width = `${projectedProgress}%`;

    window.setTimeout(() => {
      preview.style.opacity = '0';
      const headline = meter.querySelector('[data-simedge-shipping-headline]');
      const copy = meter.querySelector('[data-simedge-shipping-copy]');
      const reachesThreshold = meter.dataset.reachesThreshold === 'true';

      if (reachesThreshold) {
        meter.classList.add('simedge-free-shipping--success');
        transitionHeadline(headline, meter.dataset.successHeadline, reducedMotion);
        if (copy) copy.textContent = meter.dataset.successCopy;
      } else {
        transitionHeadline(headline, meter.dataset.projectedHeadline, reducedMotion);
        if (copy) copy.textContent = meter.dataset.addedCopy;
      }
    }, reducedMotion ? 0 : duration);
  });
}

document.addEventListener('cart:update', confirmProductShippingPreview);

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-simedge-shipping-terms][open]').forEach((terms) => {
    if (!terms.contains(event.target)) terms.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-simedge-shipping-terms][open]').forEach((terms) => {
    terms.removeAttribute('open');
    terms.querySelector('summary')?.focus();
  });
});
